import type { GridColDef } from '@mui/x-data-grid';
import type { ContractProductOverview } from '@weft/api-definition';
import { Price } from '../../../../../../../components/design/Price';

export const CONTRACT_PRODUCTS_OVERVIEWS_COLUMNS_KEYS = Object.freeze({
  ID: 'id',
  NAME: 'name',
  DESCRIPTION: 'description',
  TOTAL_PRICE: 'totalPrice',
} satisfies Record<string, keyof ContractProductOverview>);

export const CONTRACT_PRODUCTS_OVERVIEWS_COLUMNS: GridColDef<ContractProductOverview>[] = [
  {
    field: CONTRACT_PRODUCTS_OVERVIEWS_COLUMNS_KEYS.NAME,
    valueGetter: ({ row }) => row.name,
    headerName: 'Product',
    flex: 1,
    renderCell: ({ value }) => (
      <span className="font-sans text-black">
        {value}
      </span>
    ),
  },
  {
    field: CONTRACT_PRODUCTS_OVERVIEWS_COLUMNS_KEYS.TOTAL_PRICE,
    headerName: 'Amount',
    flex: 1,
    renderCell: ({ row }) => {
      const price = row.totalPrice;

      return (
        <span className="text-label font-sans">
          <Price
            className="font-sans text-black"
          >
            {price}
          </Price>
        </span>
      );
    },
  },
  {
    field: CONTRACT_PRODUCTS_OVERVIEWS_COLUMNS_KEYS.DESCRIPTION,
    valueGetter: ({ row }) => row.description,
    headerName: 'Description',
    flex: 1,
    renderCell: ({ value }) => (
      <span className="font-sans text-black">
        {value}
      </span>
    ),
  },

];
